<!--
 * @Author: RYL
 * @Description: 
 * @Date: 2020-07-16 16:52:43
 * @LastEditTime: 2020-11-20 16:11:40
-->
<template>
  <div>
    <table>
      <tr>
        <th>{{$t('lang.particulars.traffic')}}</th>
         <td v-if="!list.trafficDay || list.trafficDay[0] == '.'">N/A</td>
         <td v-else>{{list.trafficDay}}</td>
        <th>{{$t('lang.particulars.Monthly')}}</th>
        <td v-if="!list.trafficMonth || list.trafficMonth[0] == '.'">N/A</td>
        <td v-else>{{list.trafficMonth}}</td>
      </tr>
      <tr>
        <th>{{$t('lang.particulars.software')}}</th>
        <td v-if="!list.traffic7day || list.traffic7day[0] == '.'">N/A</td>
        <td v-else>{{list.traffic7day}}</td>
        <th>
          <p>{{$t('lang.particulars.addToTrafficDensityMap')}}</p>
        </th>
        <td v-if="!list.deviceTraffic || list.deviceTraffic[0] == '.'">N/A</td>
        <td v-else>{{list.deviceTraffic}}</td>
      </tr>
      <tr>
        <th>{{$t('lang.particulars.Operation')}}</th>
        <td>
          <el-button type="danger" size="mini" @click="handleTraffic">{{$t('lang.particulars.trafficClear')}}</el-button>
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
import { clearTraffic } from '@/api/particulars'
export default {
  props: ['list'],
  data() {
    return {

    }
  },
  methods: {
    handleTraffic(){
      this.$confirm(this.$t('lang.DeleteBox.Tetx'), this.$t('lang.Button.tips'), {
        cancelButtonText:  this.$t('lang.Button.cancel'),
        confirmButtonText: this.$t('lang.Button.confirm'),
        type: 'warning',
        center: true
      }).then(() => {
        clearTraffic(this.list.deviceDid).then(res => {
          if(res.data.code === 0) {
            this.$message.success(this.$t('lang.Button.successOperation'))
            this.$emit('showDeviceDetail')
          }else{
            this.$message.error(this.$t('lang.Button.failOperation'))
          }
        }).catch(() => {})
      }).catch(() => {})
     
    }
  }
}
</script>
<style scoped src='./particulars.css'></style>